import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=d2e0d0ea"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2e0d0ea')) {
      api.createRecord('d2e0d0ea', component.options)
    } else {
      api.reload('d2e0d0ea', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=d2e0d0ea", function () {
      api.rerender('d2e0d0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/Form.vue"
export default component.exports